import { Artefact } from "@kursk/components/ui/ContentBlock/ArtefactBlock/Artefact/Artefact";
import styles from './ArtefactBlock.module.scss'

interface IProp {
  artefact: string
}

export const ArtefactBlock = ({ artefact }: IProp) => {

  if (typeof window === "undefined") return <></>

  return <div className={styles.wrapper}>
    <Artefact
      artefact={artefact}
    />
  </div>

}
